export const Linode = {
    accessKeyId: "D7NIQ591W4POYVPR89G4",
    secretAccessKey: "fm97XGhW3aBAsYO3mCXsskPw7NsajO8YbNPVHxzD",
    region: "eu-central-1",
    endpoint: "eu-central-1.linodeobjects.com",
    hostingURL: "https://startzeit-digital-bucket.eu-central-1.linodeobjects.com",
    Bucket: "startzeit-digital-bucket"
};
